module.exports = __webpack_public_path__ + "img/data_table.bca0b40e.svg";